import {
  CITY_TYPES,
  STATE_TYPE,
  STREET_NUMBER_TYPE,
  STREET_TYPES,
  ZIP_TYPE,
} from './google_maps_constants';

type IntermediatePart = 'number' | 'zipCode' | 'street' | 'city' | 'state';

const COMPONENTS: Array<{ key: IntermediatePart; components: string[] }> = [
  { key: 'number', components: [STREET_NUMBER_TYPE] },
  { key: 'zipCode', components: [ZIP_TYPE] },
  { key: 'street', components: [...STREET_TYPES] },
  { key: 'city', components: [...CITY_TYPES] },
  { key: 'state', components: [STATE_TYPE] },
];

export function extractAddressFromGeocoderResult(
  result: google.maps.GeocoderResult,
) {
  const { address_components: addressComponents } = result;

  const intermediateAddress = {
    number: '',
    street: '',
    city: '',
    state: '',
    zipCode: '',
  };

  addressComponents.forEach((component) => {
    COMPONENTS.map(({ key, components }) => {
      if (
        components.indexOf(component.types[0]) !== -1 ||
        components.indexOf(component.types[1]) !== -1 // Fall back to secondary type
      ) {
        intermediateAddress[key] =
          key === 'state' ? component.short_name : component.long_name;
      }
    });
  });

  const { number, street, city, state, zipCode } = intermediateAddress;

  return {
    street: number ? `${number} ${street}` : street,
    city,
    state,
    zipCode,
    latitude: result.geometry.location.lat(),
    longitude: result.geometry.location.lng(),
    googleAddressType: result.types[0],
  };
}
